<template>
  <v-container fluid class="register-wrapper">
    <!-- <register-top-bar></register-top-bar> -->
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <vue100vh :css="{ height: 'calc(100rvh - 145px)' }">
          <router-view class="register-content" />
        </vue100vh>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import RegisterTopBar from '@/components/RegisterTopBar'
import vue100vh from 'vue-100vh'

export default {
  mounted() {
    window.scrollTo(0, 0)
  },
  components: {
    // RegisterTopBar,
    vue100vh
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.register-wrapper {
  margin-top: 130px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-top: 95px;
  }
}

.register-content {
  font-size: 14px;

  h2 {
    font-size: 20px;
    line-height: 30px;
    text-transform: uppercase;
  }

  h3 {
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
  }

  h4 {
    font-size: 14px;
    line-height: 20px;
  }

  p,
  .v-btn.v-size--x-large {
    font-size: 14px !important;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  @media #{map-get($display-breakpoints, 'md-and-up')} {
    max-width: 500px;
  }
}

.register-steps-content {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.register-top {
  padding: 60px 0 30px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 30px 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.register-bottom {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    text-align: center;
    padding-bottom: 15px;
  }
}

.register-button {
  width: 220px;
}

.register-link {
  display: inline-block;
  border-bottom: solid 2px #000;
  color: #000 !important;
  text-decoration: none;
}
</style>
